import _regeneratorRuntime from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/asyncToGenerator";
import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _createClass from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/createClass";
import _possibleConstructorReturn from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/getPrototypeOf";
import _inherits from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/inherits";
import axios from "axios";
import BaseData from "./BaseData";

var PropertyRequirements =
/*#__PURE__*/
function (_BaseData) {
  _inherits(PropertyRequirements, _BaseData);

  function PropertyRequirements() {
    _classCallCheck(this, PropertyRequirements);

    return _possibleConstructorReturn(this, _getPrototypeOf(PropertyRequirements).call(this, "PropertyRequirements"));
  }

  _createClass(PropertyRequirements, [{
    key: "AllowModuleRequestSubmitOrCreate",
    value: function () {
      var _AllowModuleRequestSubmitOrCreate = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(projectId, module) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", axios.get("/api/".concat(this._controller, "/AllowModuleRequestSubmitOrCreate/").concat(projectId, "/").concat(module)));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function AllowModuleRequestSubmitOrCreate(_x, _x2) {
        return _AllowModuleRequestSubmitOrCreate.apply(this, arguments);
      }

      return AllowModuleRequestSubmitOrCreate;
    }()
  }, {
    key: "GetByProjectId",
    value: function () {
      var _GetByProjectId = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(projectId) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", axios.get("api/".concat(this._controller, "/GetByProjectId/").concat(projectId)));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function GetByProjectId(_x3) {
        return _GetByProjectId.apply(this, arguments);
      }

      return GetByProjectId;
    }()
  }, {
    key: "GetSingleItemByProjectId",
    value: function () {
      var _GetSingleItemByProjectId = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(projectId) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", axios.get("api/".concat(this._controller, "/GetSingleItemByProjectId/").concat(projectId)));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function GetSingleItemByProjectId(_x4) {
        return _GetSingleItemByProjectId.apply(this, arguments);
      }

      return GetSingleItemByProjectId;
    }()
  }]);

  return PropertyRequirements;
}(BaseData);

export default new PropertyRequirements();